import "./AnimatedDots.css";

export default function AnimatedDots() {
  return (
    <span className="animated-dots" aria-hidden="true">
      <span className="animated-dots-dot">.</span>
      <span className="animated-dots-dot">.</span>
      <span className="animated-dots-dot">.</span>
    </span>
  );
}
